import React from 'react';
import { setUIState } from '@plone/volto/actions/form/form';
import config from '@plone/volto/registry';
import cx from 'classnames';
import messages from 'govbr.frontend.policy/messages/accordion';
import AnimateHeight from 'react-animate-height';
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion, Input } from 'semantic-ui-react';

import styles from './edit.module.less';

const AccordionEdit = (props) => {
  const {
    children,
    handleTitleChange,
    handleTitleClick,
    uid,
    panel,
    data,
    index,
    intl,
  } = props;

  const didInit = React.useRef(false);
  const gridSelected = useSelector((state) => state.form.ui.gridSelected);
  const dispatch = useDispatch();

  const [activeIndex, setActiveIndex] = React.useState([0]);
  const accordionConfig = config.blocks.blocksConfig.accordion;
  const isActive = activeIndex.includes(index);

  // Otimização de performance: em acordeões com muitos itens, montar o
  // BlocksForm (children) de todos os painéis de uma só vez torna a edição
  // extremamente lenta, pois todos os blocos internos ficam ativos ao mesmo
  // tempo mesmo com o painel fechado. Por isso, o conteúdo só é montado na
  // primeira vez que o painel é aberto e permanece montado depois disso
  // (evitando perda de estado ao fechar/reabrir o mesmo painel).
  const hasBeenActiveRef = React.useRef(isActive);
  if (isActive) {
    hasBeenActiveRef.current = true;
  }

  React.useEffect(() => {
    const gridData = data.data;
    if (
      gridData &&
      gridData.blocks &&
      gridData.blocks_layout?.items &&
      gridSelected
    ) {
      const colId = Object.keys(gridData.blocks).find((colId) => {
        const col = gridData.blocks[colId];
        return col && col.blocks && col.blocks[gridSelected];
      });

      const gridIndex = gridData.blocks_layout?.items.findIndex((idItems) => {
        return idItems === colId;
      });

      if (gridIndex >= 0) {
        setActiveIndex([gridIndex]);
      }

      dispatch(setUIState({ gridSelected: null }));
    } else if (!didInit.current) {
      data.openOnStart ? setActiveIndex([0]) : setActiveIndex([]);
    }
    didInit.current = true;
  }, [gridSelected, data, dispatch]);

  const handleClick = (e, itemProps) => {
    if (e.target.closest('.input-accordion-title')) {
      return; // Evita que o clique no Input do titulo passe pelo handleClick
    }

    const { index } = itemProps;
    if (!data.exclusive) {
      const newIndex =
        activeIndex.indexOf(index) === -1
          ? [...activeIndex, index]
          : activeIndex.filter((item) => item !== index);

      setActiveIndex(newIndex);
    } else {
      const newIndex =
        activeIndex.indexOf(index) === -1
          ? [index]
          : activeIndex.filter((item) => item !== index);

      setActiveIndex(newIndex);
    }
  };

  const titleClass = cx('accordion-title', {
    'align-arrow-left': props?.data?.left_arrows,
    'align-arrow-right': !props?.data?.left_arrows,
    [styles.active]: isActive,
    [styles.group]: data.groups,
    'text-interactive': !data.groups,
  });

  return (
    <Accordion
      className={
        // data.styles ?
        // data.styles.theme :
        accordionConfig?.defaults?.theme
      }
      {...accordionConfig.options}
    >
      <React.Fragment>
        <Accordion.Title
          as={data.title_size}
          active={isActive}
          index={index}
          onClick={handleClick}
          className={titleClass}
        >
          {isActive ? (
            <span className="fa-solid fa-angle-up" />
          ) : (
            <span className="fa-solid fa-angle-down" />
          )}
          {!data.readOnlyTitles ? (
            <Input
              fluid
              className="input-accordion-title"
              transparent
              placeholder={intl.formatMessage(messages.EnterTitle)}
              value={panel?.title || ''}
              onClick={(e) => {
                handleTitleClick();
              }}
              onChange={(e) => handleTitleChange(e, [uid, panel])}
            />
          ) : (
            <span>{panel?.title}</span>
          )}
        </Accordion.Title>
        <AnimateHeight
          animateOpacity
          duration={500}
          height={isActive ? 'auto' : 0}
        >
          <Accordion.Content active={isActive}>
            {hasBeenActiveRef.current ? children : null}
          </Accordion.Content>
        </AnimateHeight>
      </React.Fragment>
    </Accordion>
  );
};

export default injectIntl(AccordionEdit);
